import React from "react";

const HeatMap = () => {
  return (
    <div className="md:px-24 px-4 md:pb-10 pb-6">
      <div >

        {/* ADMINISTRATIVE Section */}
        <div className="mb-6 mt-4 md:mt-16 mt-3">


          <div className="mt-2">
            <div className="flex md:flex-row items-start gap-1 md:gap-[110px] mb-2">
              <div className="w-[70px] md:w-[200px]">
                <p className="text-[#F38323] font-bold text-[6px] md:text-[20px]">ENTERPRISES</p>
              </div>
              <div className="grid grid-cols-9 md:grid-cols-9 md:gap-[12px] gap-[2px] flex-1">
                {[
                  'GAUTTENG', 'NORTHWEST', 'FREE STATE', 'WESTERN CAPE', 'NOTHERN CAPE',
                  'EASTERN CAPE', 'KWAZULU NATAL', 'LIMPOPO', 'MPUMALA NGA'
                ].map((region, i) => (
                  <div key={i} className="text-[4px] md:text-[14px] tracking-wide text-black font-extrabold md:px-1 text-left md:w-[95px]">
                    {region}
                  </div>
                ))}
              </div>
            </div>
            <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

            <div className="overflow-x-auto">
              <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-2 gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">

                {/* Row 1 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Farmers
                </div>
                {["345", "545", "279", "199", "175", "512", "572", "321", "409"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 2 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Communities
                </div>
                {["55", "34", "23", "39", "31", "59", "61", "45", "48"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 3 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Cooperatives
                </div>
                {["18", "10", "9", "15", "12", "17", "21", "16", "19"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 4 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Projects
                </div>
                {["3", "0", "2", "1", "0", "2", "3", "2", "3"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 5 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Persons with disability
                </div>
                {["15", "5", "4", "6", "5", "16", "19", "14", "15"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 6 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Youth
                </div>
                {["189", "99", "102", "78", "81", "102", "234", "189", "270"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}
                {/* Row 6 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Women
                </div>
                {["155", "145", "98", "69", "67", "99", "155", "137", "131"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}
              </div>
            </div>

          </div>
          <div className="mt-8">
            <div className="flex md:flex-row items-start gap-1 md:gap-[110px] mb-2">
              <div className="w-[70px] md:w-[200px]">
                <p className="text-[#F38323] font-bold text-[6px] md:text-[20px]">LAND</p>
              </div>

            </div>
            <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

            <div className="overflow-x-auto ">
              <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-2 gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">

                {/* Row 1 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Owned
                </div>
                {["345", "345", "345", "345", "345", "345", "345", "345", "345"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 2 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Leased
                </div>
                {["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 3 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Commonage
                </div>
                {["345", "345", "345", "345", "345", "345", "345", "345", "345"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 4 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Community owned
                </div>
                {["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 5 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Community leased
                </div>
                {["345", "345", "345", "345", "345", "345", "345", "345", "345"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 6 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Municipal Land
                </div>
                {["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 7 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  House with a plot
                </div>
                {["345", "345", "345", "345", "345", "345", "345", "345", "345"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 8 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Road Side vacant land
                </div>
                {["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 9 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Urban Lot
                </div>
                {["345", "345", "345", "345", "345", "345", "345", "345", "345"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 10 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Community Food garden allocation
                </div>
                {["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 11 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  Village / Local/ Tribunal Authority allocation
                </div>
                {["345", "345", "345", "345", "345", "345", "345", "345", "345"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}

                {/* Row 12 */}
                <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
                  No Land Yet
                </div>
                {["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"]
                  .map((num, idx) => (
                    <div
                      key={idx}
                      className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                    >
                      {num}
                    </div>
                  ))}
              </div>
            </div>


          </div>
        </div>


      </div>
    </div>
  );
};

export default HeatMap;
